<template>
  <div>
    <table-element v-bind="tableOpt" v-on:changeOrder="changeOrder" v-on:rowClick="rowClick">
      <template #city="{ value }">{{ value.title }}</template>
      <template #status="{ value }">{{ value.title }}</template>
      <template #phones="{ value }">{{ value ? value.join(',') : '' }}</template>
      <template #address="{ value }">{{ value ? value.join(',') : '' }}</template>
    </table-element>

    <paginator :model="meta.list_data" @change="changePage" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TableElement from '@/components/common/TableElement';

export default {
  name: 'all-dealers-table',

  components: {
    TableElement,
  },

  props: {
    tableOptions: Object,
  },

  computed: {
    ...mapGetters({
      meta: 'dealers/meta',
    }),

    tableOpt() {
      return {
        ...this.tableOptions,

        columns: [
          { label: 'Название', name: 'title' },
          { label: 'Город', name: 'city' },
          { label: 'Адрес', name: 'address' },
          { label: 'Еmail', name: 'email' },
          { label: 'Телефон', name: 'phones' },
          { label: 'Статус', name: 'status' },
          { label: 'Удален', name: 'deleted_at' },
        ],
      };
    },
  },

  methods: {
    changeOrder(column) {
      this.$emit('changeOrder', column);
    },

    changePage(skip) {
      this.$emit('changePage', skip);
    },

    rowClick(id) {
      this.$emit('rowClick', id);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
